import { Component, createRef } from "react";
import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { GCPCreateRow, GCPRow } from "namirasoft-credential";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface GCPEditPageProps extends NSARouterMakerResult, CredentialProps
{
    isEdit: boolean;
}

export default class GCPEditPage extends Component<GCPEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSABoxSecret_CredentialsSecretID = createRef<NSABoxSecret>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <CredentialLayout<GCPRow, GCPCreateRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to edit a Google Cloud Platform (GCP) credential by updating its name, service account key, or description. The service account key is kept as a protected secret, and any application set up to use the credential applies the updated value." : "This section allows you to create a Google Cloud Platform (GCP) credential using a service account key by entering a name and the service account JSON key. Namirasoft encrypts the sensitive data for secure access, and any Namirasoft application you set up to use it can then authenticate to GCP."
                }}
                pages={{
                    entity: CredentialEntities.gcp(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): GCPCreateRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let credentials = this.NSABoxSecret_CredentialsSecretID.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            name,
                                            credentials,
                                            description,
                                            gcp_category: [],
                                            gcp_field: [],
                                            gcp_tag: [],
                                        };
                                    },
                                    setRow: (row: GCPRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSABoxSecret_CredentialsSecretID.current?.setValue(row.credentials_secret_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/gcp/#field-name" }}
                        style={{ width: NSBox.width.double }}
                    />
                                        <NSABoxSecret
                        ref={this.NSABoxSecret_CredentialsSecretID}
                        {...this.props}
                        required
                        title="Credentials"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/gcp/#field-credentials" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        required={false}
                        title="Description"
                        info={{ link: "https://namirasoft.com/credential/console-guide/gcp/#field-description" }}
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </CredentialLayout >
        );
    }
}